// private

// public
const getTabItem = (tabKey, title, component, props = {}, listeners = {}) => ({ tab: tabKey, title, component, props, listeners });

const AppTabsService = { getTabItem };

export default AppTabsService;
